import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const StyledIcon = styled(SWReactIcons)`
    height: 24px;
    width: 24px;
    display: flex;
    padding-left: 16px;
    margin-right: -8px;
`;
